import { CommonModule } from '@angular/common'
import { Component, effect, Input, signal } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { Themes } from '../../enums/enums'

@Component({
  selector: 'ddc-card-category',
  templateUrl: './ddc-card-category.component.html',
  styleUrls: ['./ddc-card-category.component.scss'],
  imports: [AngularMaterialsModules, CommonModule, MatIconModule],
})
export class DdcCardCategoryComponent {
  @Input() category: string = ''
  isLightTheme = signal<boolean>(true)
  isDarkTheme = signal<boolean>(false)
  isPaperTheme = signal<boolean>(false)

  constructor(public themeService: ThemeService) {
    effect(() => {
      let theme: Themes
      this.themeService.theme$.subscribe(t => (theme = t))
      this.isLightTheme.set(theme === Themes.LIGHT)
      this.isDarkTheme.set(theme === Themes.DARK)
      this.isPaperTheme.set(theme === Themes.PAPER)
    })
  }
}
